import {CategoriesPanel} from "./CategoriesPanel.js";
import {ManagedDropDown} from "./ManagedDropDown.js";

const DROP_H_MARGIN = 6;
const INDENT = 18;

export class CategoriesDropDown extends ManagedDropDown {
	constructor(widget, state, categories, field, editor) {
		super(widget, state, field);
		this.cats = categories;
		this.editor = editor;
		this.rebuild();
	}


	makePanel() {
		const p = super.makePanel();
		p.addClass('cats-dropdown');
		p.addClass('ns');
		this.generateDropDown(p);
		return p;
	}

	remakePanel() {
	}

	setFilter(query) {
		// Show all
		this.root.find('div[data-filter]').show();
		if (query) {
			this.root.find('div[data-filter]:not(div[data-filter*="'+this.queryEscape(query)+'"])').hide();
		}
	}

	queryEscape(query) {
		return query.toLowerCase().trim();
	}

	generateDropDown(drop) {
		const childrenPanel = CategoriesPanel.generateChildrenPanel(this.cats.children, 0, null, true);
		drop.append(childrenPanel);
		childrenPanel.on("selectionchange", function(e, id, checked, labelClickedFirst) {
				this.editor.selectionChanged(id, checked, labelClickedFirst);
				this.beforeShow();
			}.bind(this));
	}

	beforeShow() {
		super.beforeShow();
		this.syncWithWidgetWidth();
	}

	selectedValues() {
		const allChecked = this.root.find("input[type=checkbox]:checked");
		return CategoriesPanel.extractDataFromCheckboxes(allChecked);
	}

	updateScreen(dataArray) {
		const all = this.root.find("input[type=checkbox]");
		CategoriesPanel.updateCheckboxesFromData(all, dataArray);
	}

	/**
	 * Syncronize drop down width and width of widget
	 */
	syncWithWidgetWidth() {
		const w = this.widget.outerWidth();
		this.root.css("min-width", w + "px");
	}
}